import * as React from "react";

import {
  createDataSourceIntersectionContext,
  GenericDataSourceIntersectionProvider,
} from "../../../Common";

import { CheckoutModel_MyBag } from "../../model";

import { useDataMutableSourceSuccessClientStorageData_MyBag_GenericIntersectable } from "../data-mutable-source-success-client-storage-data";
import { useDataMutationMyBagItemChangeQuantity } from "../data-mutation--mybag-item-change-quantity";
import { useDataMutationMyBagItemRemove } from "../data-mutation--mybag-item-remove";
import { useDataMutationMyBagPromoCodeApply } from "../data-mutation--mybag-promo-code-apply";
import { useDataMutationMyBagPromoCodeRemove } from "../data-mutation--mybag-promo-code-remove";
import { useDataMutationShippingSetBillingAddressesOnCart } from "../data-mutation--shipping-set-billing-addresses-on-cart";
import { useDataMutationShippingSetGuestEmail } from "../data-mutation--shipping-set-guest-email";
import { useDataMutationShippingSetShippingAddressesOnCart } from "../data-mutation--shipping-set-shipping-addresses-on-cart";
import { useDataMutationShippingSetShippingMethodsOnCart } from "../data-mutation--shipping-set-shipping-methods-on-cart";
import { useDataSourceMyBagQuery } from "../data-source--mybag-provider";
import { useDataSourceMyBagTotalsController } from "../data-source--mybag-totals-provider";

type ThisDataConsumerInterface = CheckoutModel_MyBag;

export const MyBagDataSourceIntersectionProvider: React.FunctionComponent = (
  props
) => {
  const dataSourceMyBagQuery = useDataSourceMyBagQuery();

  const dataMutationMyBagItemRemove = useDataMutationMyBagItemRemove();
  const dataMutationMyBagItemChangeQuantity =
    useDataMutationMyBagItemChangeQuantity();

  const dataMutationMyBagPromoCodeApply = useDataMutationMyBagPromoCodeApply();
  const dataMutationMyBagPromoCodeRemove =
    useDataMutationMyBagPromoCodeRemove();

  const dataMutationShippingSetGuestEmail =
    useDataMutationShippingSetGuestEmail();
  const dataMutationShippingSetShippingAddressesOnCart =
    useDataMutationShippingSetShippingAddressesOnCart();
  const dataMutationShippingSetShippingMethodsOnCart =
    useDataMutationShippingSetShippingMethodsOnCart();
  const dataMutationShippingSetBillingAddressesOnCart =
    useDataMutationShippingSetBillingAddressesOnCart();

  const dataMutableSourceSuccessClientStorageData =
    useDataMutableSourceSuccessClientStorageData_MyBag_GenericIntersectable();

  const { invalidate } = useDataSourceMyBagTotalsController();

  const dataSources = React.useMemo(
    () => [
      dataSourceMyBagQuery,
      dataMutationMyBagItemRemove,
      dataMutationMyBagItemChangeQuantity,
      dataMutationMyBagPromoCodeApply,
      dataMutationMyBagPromoCodeRemove,
      dataMutationShippingSetGuestEmail,
      dataMutationShippingSetShippingAddressesOnCart,
      dataMutationShippingSetShippingMethodsOnCart,
      dataMutationShippingSetBillingAddressesOnCart,
      dataMutableSourceSuccessClientStorageData,
    ],
    [
      dataSourceMyBagQuery,
      dataMutationMyBagItemRemove,
      dataMutationMyBagItemChangeQuantity,
      dataMutationMyBagPromoCodeApply,
      dataMutationMyBagPromoCodeRemove,
      dataMutationShippingSetGuestEmail,
      dataMutationShippingSetShippingAddressesOnCart,
      dataMutationShippingSetShippingMethodsOnCart,
      dataMutationShippingSetBillingAddressesOnCart,
      dataMutableSourceSuccessClientStorageData,
    ]
  );

  React.useEffect(() => {
    invalidate();
  }, [invalidate, dataSources]);

  return (
    <GenericDataSourceIntersectionProvider<ThisDataConsumerInterface>
      context={MyBagDataSourceIntersectionContext}
      dataSources={dataSources}
    >
      {props.children || []}
    </GenericDataSourceIntersectionProvider>
  );
};

export const [
  MyBagDataSourceIntersectionContext,
  useMyBagDataSourceIntersection,
] = createDataSourceIntersectionContext<ThisDataConsumerInterface>();
